import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { FileExplorerNewConfig } from "../../models/file-explorer-new-config.model";
import { DwMdSectionConfigBaseComponent2, DwComponentSectionConfigPreference, DwMdItem } from '@devwareapps/devware-cap';

@Component({
    selector: 'app-file-explorer-new-config',
    templateUrl: './file-explorer-new-config.component.html',
    styleUrls: ['./file-explorer-new-config.component.scss']
})
export class FileExplorerNewConfigComponent extends  DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<FileExplorerNewConfig>> {
    configFormGroup : FormGroup;
    itemMetaData: DwMdItem;

    setupForm() {
        // Add config fields to the form
    
        this.configFormGroup = new FormGroup({
          attachmentId: new FormControl(),
        });
    
        this.formGroup.addControl('config', this.configFormGroup);
    
      }
    
    
      setupAttributeList() {
        this.getItemMetaData(this.itemName)
          .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
          });
      }
}